import { useState } from "react";
import styles from "./SelectVR.module.css";

import arrow from "../../assets/images/icons/selector_down_arrow.png";

const getCurrentDateInput = () => {
  const dateObj = new Date();

  // get the month in this format of 04, the same for months
  const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  const day = ("0" + dateObj.getDate()).slice(-2);
  const year = dateObj.getFullYear();

  const shortDate = `${year}-${month}-${day}`;

  return shortDate;
};

const Select = ({ datepicker, selected, options, callback }) => {
  const [openOptions, setOpenOptions] = useState(false);
  if (!datepicker) {
    return (
      <div className={styles.input_wrapper01}>
        <div
          onClick={() => {
            setOpenOptions(!openOptions);
          }}
          className={styles.input01}
        >
          {selected}
          <img src={arrow} className={styles.arrow} alt="arrow" />
        </div>
        {openOptions &&
          Array.isArray(options) &&
          options.length > 0 &&
          options.map((item, index) => {
            return (
              <div
                onClick={() => {
                  callback(item);
                  setOpenOptions(false);
                }}
                className={styles.options01}
              >
                {item.name}
              </div>
            );
          })}
      </div>
    );
  } else {
    return (
      <input
        type={"date"}
        defaultValue={getCurrentDateInput()}
        onChange={callback}
        className={styles.input02}
      />
    );
  }
};
export default Select;
